angular.module('ui-ng-ax').service('phxMobileTrapFocus', () => {
  const getTopLevelNodes = () => {
    let topLevelNodes = [];
    const bodyEl = document.querySelector('body');
    if (bodyEl) {
      topLevelNodes = Array.from(bodyEl.children);
    }
    return topLevelNodes;
  };
  const enableTrapFocus = (tagName) => {
    getTopLevelNodes().forEach((el) => {
      if (el.nodeName.toLowerCase() !== tagName.toLowerCase()) {
        el.setAttribute('aria-hidden', 'true');
        el.setAttribute('inert', true);
      }
    });
  };
  const disableTrapFocus = (tagName) => {
    getTopLevelNodes().forEach((el) => {
      if (el.nodeName !== tagName.toLowerCase()) {
        el.removeAttribute('aria-hidden');
        el.removeAttribute('inert');
      }
    });
  };
  return {
    enableTrapFocus,
    disableTrapFocus
  };
});



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-ax/src/servants/phx_mobile_ax_trap_focus.es.js